export default {
  toaster: 'b-toaster-top-center',
  variant: 'danger',
  autoHideDelay: 3000,
  solid: true,
  noHoverPause: true,
};
